export const MODES_TYPE = {
	hover: 'HOVER',
	default: 'DEFAULT',
}

export const HOVER_SUFFIX = ':hover'

export const DEFAULT_DATA_MODE = '[data-mode=default]'

export const HOVER_DATA_MODE = '[data-mode=hover]'

export const getHoverCompId = (compId: string): string => `${compId}${HOVER_SUFFIX}`

export const getDefaultCompId = (compId: string): string => (compId ? compId.replace(HOVER_SUFFIX, '') : compId)

const COMP_SELECTOR_PLACEHOLDER = '#<%= compId %>'

export const compIdToCssSelector = (compId: string): string => {
	const defaultCompId = getDefaultCompId(compId)
	return compId.endsWith(HOVER_SUFFIX) ? `${HOVER_DATA_MODE} #${defaultCompId}` : `${COMP_SELECTOR_PLACEHOLDER}`
}
